import { render, staticRenderFns } from "./FreshdeskSupport.vue?vue&type=template&id=44da5cd0&scoped=true&"
import script from "./FreshdeskSupport.vue?vue&type=script&lang=js&"
export * from "./FreshdeskSupport.vue?vue&type=script&lang=js&"
import style0 from "./FreshdeskSupport.vue?vue&type=style&index=0&id=44da5cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da5cd0",
  null
  
)

export default component.exports